import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { RouterModule, Routes } from '@angular/router';


import { FreyaCommonModule } from '../freya-common/freya-common.module';
import { LibModule } from '../lib.ts/lib.module';
import { NotAuthenticatedGuard } from '../shared/guards/not-authenticated.guard';

import { SharedModule } from '../shared/shared.module';

import { AppLoggedOutComponent } from './app.logged-out.component';


import { AuthFooterComponent } from './auth-footer/auth-footer.component';
import { AuthRedirectComponent } from './auth-redirect.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SignUpComponent } from './sign-up/sign-up.component';


const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/auth/login',
  },
  {
    path: 'login',
    component: AuthRedirectComponent,
    canActivate: [ NotAuthenticatedGuard ],
    data: {
      customTitle: 'Login',
    },
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    data: {
      customTitle: 'Reset Password',
    },
  },
  {
    path: 'signup',
    component: SignUpComponent,
    data: {
      customTitle: 'Sign up',
    },
  },
  {
    path: 'logged-out',
    component: AppLoggedOutComponent,
    data: {
      customTitle: 'Logged out',
    },
  },
];

@NgModule({
  declarations: [
    AuthRedirectComponent,
    AppLoggedOutComponent,
    SignUpComponent,
    ResetPasswordComponent,
    AuthFooterComponent,
  ],
  imports: [
    FreyaCommonModule,
    LibModule,
    CommonModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    SharedModule
  ]
})
export class AuthenticationModule { }
